/**
 * ActiveCampaign footer newsletter — SB UI, config via data attributes on [data-sb-ac-form].
 */
(function () {
  var FORM_SELECTOR = '[data-sb-ac-form]';
  var EMAIL_RE = /^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;

  function getForm(id) {
    return document.getElementById('_form_' + id + '_');
  }

  function formIdOf(form) {
    return form.getAttribute('data-ac-form-id') || '';
  }

  function procUrlOf(form) {
    return form.getAttribute('data-ac-proc-url') || form.getAttribute('action') || '';
  }

  function setSubmitState(form, processing) {
    var button = form.querySelector('[id^="_form"][id$="_submit"]');
    if (!button) return;
    button.disabled = processing;
    button.classList.toggle('is-processing', processing);
  }

  function clearInlineError(form) {
    var existing = form.querySelector('.sb-footer__form-error[data-ac-error]');
    if (existing) existing.remove();
  }

  function showInlineError(form, message) {
    clearInlineError(form);
    var content = form.querySelector('._form-content') || form;
    var err = document.createElement('p');
    err.className = 'sb-footer__form-error';
    err.setAttribute('data-ac-error', 'true');
    err.setAttribute('role', 'alert');
    err.textContent = message;
    content.insertBefore(err, content.firstChild);
  }

  var prevThankYou = window._show_thank_you;
  var prevError = window._show_error;
  var prevUnsubscribe = window._show_unsubscribe;
  var prevPcConfirmation = window._show_pc_confirmation;
  var prevLoadScript = window._load_script;

  window._show_thank_you = function (id, message, trackcmp_url, email) {
    var form = getForm(id);
    if (form && form.hasAttribute('data-sb-ac-form')) {
      var content = form.querySelector('._form-content');
      var thankYou = form.querySelector('._form-thank-you');
      var fallback = form.getAttribute('data-success-message') || '';

      if (content) content.style.display = 'none';
      if (thankYou) {
        thankYou.innerHTML = message || fallback;
        thankYou.classList.add('sb-footer__form-success');
        thankYou.style.display = 'block';
        thankYou.setAttribute('role', 'status');
        thankYou.setAttribute('tabindex', '-1');
        thankYou.focus();
      }
      setSubmitState(form, false);
      if (typeof window._form_callback === 'function') window._form_callback(id);
      return;
    }
    if (typeof prevThankYou === 'function') {
      return prevThankYou.apply(this, arguments);
    }
  };

  window._show_error = function (id, message, html) {
    var form = getForm(id);
    if (form && form.hasAttribute('data-sb-ac-form')) {
      showInlineError(form, message || 'Đăng ký không thành công. Vui lòng thử lại.');
      setSubmitState(form, false);
      return;
    }
    if (typeof prevError === 'function') {
      return prevError.apply(this, arguments);
    }
  };

  window._show_unsubscribe = function () {
    var id = arguments[0];
    var form = getForm(id);
    if (form && form.hasAttribute('data-sb-ac-form')) {
      return window._show_thank_you.apply(this, arguments);
    }
    if (typeof prevUnsubscribe === 'function') {
      return prevUnsubscribe.apply(this, arguments);
    }
  };

  window._show_pc_confirmation = function (id) {
    var form = getForm(id);
    if (form && form.hasAttribute('data-sb-ac-form')) {
      return window._show_thank_you(id, form.getAttribute('data-success-message'));
    }
    if (typeof prevPcConfirmation === 'function') {
      return prevPcConfirmation.apply(this, arguments);
    }
  };

  function loadScript(url, callback, isSubmit, formId) {
    var script = document.createElement('script');
    var done = false;
    script.charset = 'utf-8';
    script.src = url;
    script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'complete')) {
        done = true;
        if (callback) callback();
      }
    };
    script.onerror = function () {
      if (isSubmit && formId) {
        window._show_error(formId, 'Đăng ký không thành công. Vui lòng thử lại.');
      }
    };
    document.head.appendChild(script);
  }

  window._load_script = function (url, callback, isSubmit) {
    if (typeof prevLoadScript === 'function') {
      return prevLoadScript.apply(this, arguments);
    }
    return loadScript(url, callback, isSubmit);
  };

  function serializeForm(form) {
    var parts = [];
    var elements = form.elements;
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!el.name || el.disabled) continue;
      if (el.type === 'submit' || el.type === 'button' || el.type === 'file') continue;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
      parts.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value));
    }
    return parts.join('&');
  }

  function validate(form) {
    clearInlineError(form);
    var email = form.querySelector('input[name="email"]');
    if (!email) return false;

    email.classList.remove('sb-footer__input--error');
    var value = (email.value || '').trim();
    email.value = value;

    if (!value) {
      email.classList.add('sb-footer__input--error');
      showInlineError(form, 'Vui lòng nhập email.');
      email.focus();
      return false;
    }

    if (!EMAIL_RE.test(value)) {
      email.classList.add('sb-footer__input--error');
      showInlineError(form, 'Vui lòng nhập email hợp lệ.');
      email.focus();
      return false;
    }

    return true;
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-sb-ac-bound') === 'true') return;
    form.setAttribute('data-sb-ac-bound', 'true');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!validate(form)) return;

      var id = formIdOf(form);
      var procUrl = procUrlOf(form);
      if (!id || !procUrl) return;

      setSubmitState(form, true);
      clearInlineError(form);

      var serialized = serializeForm(form).replace(/%0A/g, '\\n');
      loadScript(procUrl + '?' + serialized + '&jsonp=true', null, true, id);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) {
      bindForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
